<!--
 * @Author: your name
 * @Date: 2020-11-12 17:40:42
 * @LastEditTime: 2022-11-02 09:23:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/BottomPopupDialog/index.vue
-->
<style scoped lang="sass">

.app_container
  position: relative
  display: flex
  flex-direction: column
  justify-content: space-between
  height: calc(var(--vh, 1vh) * 100 - 66px)

  .title
    position: absolute
    top: 11PX
    padding: 5PX
    width: calc( 100% - 30PX )
    height: 36PX
    line-height: 26PX
    color: #334455
    font-size: 18PX
    font-weight: bold
    text-align: center

.close_icon
  position: absolute
  top: 0
  right: 0
  z-index: 999
  padding: 10px
  color: var(--menu-primary-background-colour) !important
  cursor: pointer

::v-deep
  .van-button--primary
    border: none
    border-radius: 5PX !important

.loading_popup
  position: absolute !important
  left: 0

.top_popup_dialog
  margin-top: 22PX
</style>

<template lang="pug">
van-popup(
  :value="show"
  :close-on-click-overlay="false"
  round
  :position="position"
)
  .app_container()
    .title(v-if="title") {{ title }}
    div(:class="{'top_popup_dialog': title}")
      icon(v-if="showCloseIcon" size="26").close_icon(@click="closeDialog") close
      slot(name="popup-dialog")
    py-loading.loading_popup(:showLoading="showPopupLoading" :size="popupLoadingSize")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'

@Component({
  model: {
    prop: 'show',
    event: 'changeShow'
  },

  props: {
    show: {
      type: Boolean
    },

    title: {
      type: String
    },

    showCloseIcon: {
      type: Boolean,
      default: true
    },

    round: {
      type: Boolean,
      default: true
    },

    isMaxHeight: Boolean,

    color: {
      type: String,
      default: '#000'
    },

    popupLoadingSize: {
      type: String,
      default: '50'
    },

    showPopupLoading: {
      type: Boolean,
      default: false
    },

    position: {
      type: String,
      default: 'bottom'
    }
  }
})

class BottomPopupDialog extends Vue {
  mounted () {
    this._setVh()
  }

  closeDialog() {
    this.$emit('changeShow', false)
  }

  _setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
}

export default BottomPopupDialog
</script>
